// @ts-ignore
import InboomaBaseView from "../../views/InboomaBaseView";

export default InboomaBaseView.prototype.t;
